export default {
    "intro_title_1": "開始擁有第一支藏酒！",
    "intro_title_2": "現在就開始使用 CELLWINE 銅板酒窖",
    "by_delivery": "物流寄送",
    "by_on_site": "自行親送",
    "by_order": "存酒預約單",
    "send_order":"送出預約",
    "quantity_label": "您本次有多少葡萄酒想存放？",
    "quantity_label_tip": "請填入本次實際存入數量",
    "referrak_label": "推薦人",
    "referrak_label_tip": "若無則免填",
    "referrak_placeholder": "請填入您的推薦人",
    "store_period_label": "預估存放時間",
    "store_period_label_tip": "填寫預估存放時間可以協助我們優化與整合我們庫存空間，並提供給您更好的藏酒服務。",
    "one_month": "1個月",
    "two_month": "2個月",
    "three_month": "3個月",
    "four_month": "4個月",
    "five_month": "5個月",
    "half_year": "半年",
    "half_to_one_year": "半年至一年",
    "over_one_year": "一年以上",
    "not_sure": "不確定",
    "trade_label": "是否有意願交易您的愛酒 ？",
    "trade_label_tip": "如您有意願交易您的愛酒，我們會提供隱私的交易平台，協助將您的愛酒找到新的主人",
    "yes": "是",
    "no": "否",
    "delivery_type_lable": "您如何將酒送達 CELLWINE銅板酒窖 寄存？",
    "delivery_type_lable_tip": "您可以於每次購買愛酒時，直接將您的愛酒寄達至CellWine．CellWine的客服人員將代收您的愛酒，並裝上酒標保護片，並放置於冷藏儲存區後通知您。",
    "delivery_type_1": "我將「自行寄達」CELLWINE",
    "delivery_type_2": "我將「宅配寄達」CELLWINE",
    "arrived_date_label": "您預計送達的日期",
    "arrived_date_label_tip": "若尚未決定可不填",
    "arrived_time_label": "請填寫送達時間",
    "arrived_time_1": "上午(10:00-12:00)",
    "arrived_time_2" : "下午(14:00-17:00)",
    "required": "*此欄位為必填",
    "delivery_title_1": "寄達 CELLWINE 銅板酒窖處理中心",
    "delivery_title_2": "確認抵達通知",
    "delivery_title_3": "付款後完成入窖",
    "delivery_title_4": "輕鬆掌握藏酒",
    "by_on_site_title_1": "親自前往 CellWine 處理中心辦理寄取",
    "by_on_site_title_2": "付款後完成入窖",
    "by_on_site_title_3": "輕鬆掌握藏酒",
    "intro_location_1": "CELLWINE 銅板酒窖處理中心",
    "intro_location_2": "106 台北市大安區新生南路二段2號B1",
    "intro_location_3": "02-23222885",
    "intro_location_4": "收件時間：週一～週五 10:00-17:00",
    "intro_location_5": "（國定假日不受理）",
    "delivery_intro_1_6": "* 請確實在物流單上填寫與個人資料相同之「姓名」及「電話號碼」。",
    "delivery_intro_1_6_1": "電話號碼",
    "delivery_intro_1_6_2": "」。",
    "delivery_intro_1_7": "寄件人電話：ＸＸ",
    "delivery_intro_1_8": "* 我們將根據此資訊確認您是否為 CellWine 銅板酒窖用戶。",
    "delivery_intro_1_9": "如果無此用戶身份，我們將致電通知您。",
    "delivery_intro_2_1": "CellWine 收到您寄送的酒後將會進行拍攝清點，迅速放置於暫存區（專業級紅酒冰箱），並以 Email/Line官方帳號向您確認清點內容。",
    "intro_to_stock_1": "確認清點內容並完成付款後，您的愛酒將會送入酒窖收藏並隨時可以預約取出享用！",
    "intro_paid_1": "您的愛酒資料將會於入窖5天內登錄至系統中，",
    "intro_paid_2": "可隨時透過CellWine APP 或網頁查看藏酒狀態。",
    "by_order_title_1": "填寫預約單",
    "by_order_content": "您無需預約即可直接將您的愛酒寄送或親送至CellWine處理中心，但填寫存酒預約單可以協助CellWine客服人員，在您的愛酒抵達CellWine處理中心前，將所需要的保護包材提前準備完成。"
}